var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 64,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.37 32.102H0v3.523h29.37v-3.523zM21.407 9.83h-5.132v14.7h3.549V12.796h1.43c1.66 0 2.604.786 2.604 2.205 0 1.394-.944 2.205-2.604 2.205h-.23v2.965h.383c3.83 0 6.076-1.913 6.076-5.17.001-3.32-2.246-5.17-6.076-5.17zM6.76 9.83l-4.937 14.7h3.575l3.354-10.39 1.68 5.194H8.258l-.868 2.965h4.001l.722 2.232h3.677L10.852 9.83H6.76z"
  }))));
}
export default SvgAp;